<div [class.--isVisible]="showNotification" class="notificationMessage">
  {{notification?.message}}
  <button class="notificationMessage__close flaticon-close" (click)="close()"></button>
</div>
